import React, { useState, useRef } from 'react';
import PartnershipForm from 'components/PartnershipForm';
import PartnershipFormSuccess from 'components/PartnershipFormSuccess';
import PartnershipFormError from 'components/PartnershipFormError';

const App = () => {
  const formElt = useRef(null);
  const [ formStatus, setFormStatus ] = useState('');

  const onFormSuccess = () => {
    setFormStatus('success');
    scrollToForm();
  };

  const onFormError = (error) => {
    console.error(error);
    setFormStatus('error');
    scrollToForm();
  };

  const scrollToForm = () => {
    const y = formElt.current.getBoundingClientRect().top + window.pageYOffset - 250;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  return (
      <>
        <section id="hero">
          <nav className="navbar p-3">
            <div className="container">
              <a className="navbar-brand" href="https://www.raxsuite.com/rpa-partnership">
                <img src="img/rax-logo.png" alt="Robotic Automation Expert" width="auto" height="50" />
              </a>
            </div>
          </nav>

          <div className="container p-4">
            <div className="row pt-4">
              <div className="col-lg-5">
                <h1 className="pb-4">Partner with RAX for <span className="text-blue fw-bold"> Automation Solutions</span></h1>
                <div className="row">
                    <div className="col-sm-6 pb-2">
                      <a role="button" className="btn btn-lg btn-warning shadow d-md-block" href="#signup">Apply for Partnership</a>
                    </div>
                    <div className="col-sm-6">
                      <a role="button" className="btn btn-lg btn-light shadow d-md-block" href="https://www.raxsuite.com/freedownload" target="_blank">Get your RPA tool now</a>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    
        <section id="quotes">
          <div id="quotesCarousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
              <button type="button" data-bs-target="#quotesCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#quotesCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
              <button type="button" data-bs-target="#quotesCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div>

            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="container p-5">
                    <div className="row">
                      <div className="col-md-1 offset-sm-3 text-center pb-4"><img src="img/t-masa.png" className="img-fluid" alt="Masahiro Hiraishi" /></div>
                        <div className="col-md-5">
                          <p className="px-3">“RPA technologies decrease cost while increasing profitability by automating the processes that are done manually. For businesses to fully embrace automation, senior management and decision-makers need to have the mindset first to make their operations organized.”</p>
                          <p className="text-yellow px-3 fw-bold m-0">Masahiro Hiraishi</p>
                          <p className="px-3">CEO, Monstarlab Omnibus</p>
                        </div>
                    </div>
                </div>
              </div>

              <div className="carousel-item">
                <div className="container p-5">
                  <div className="row">
                    <div className="col-md-1 offset-sm-3 text-center pb-4"><img src="img/t-eric.png" className="img-fluid" alt="Eric Sulit" /></div>
                      <div className="col-md-5">
                          <p className="px-3">“We have been using RAX Robots to do meter reading and billing so we can improve our collection and accounting processes. RAX EDITOR is a product that can benefit any company and I'm speaking from experience of having used the product internally in Ricoh Philippines.”</p>
                          <p className="text-yellow px-3 fw-bold m-0">Eric Sulit</p>
                          <p className="px-3">President, Ricoh Philippines</p>
                      </div>
                  </div>
                </div>
              </div>

              <div className="carousel-item">
                <div className="container p-5">
                  <div className="row">
                    <div className="col-md-1 offset-sm-3 text-center pb-4"><img src="img/t-allan.png" className="img-fluid" alt="Allan Tan" /></div>
                      <div className="col-md-5">
                          <p className="px-3">“We at Monstarlab  believe that there's always room for improvements, especially with technology. As we discover more about the wonders that RPA can do, we see to it that we serve as the bridge for our partners and clients to experience this innovation.”</p>
                          <p className="text-yellow px-3 fw-bold m-0">Allan Tan</p>
                          <p className="px-3">Managing Director, Monstarlab Manila</p>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#quotesCarousel" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#quotesCarousel" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </section>
    
        <section id="partnership">
          <div className="container p-5">
            <div className="row">
              <h1 className="p-5 text-center">Why partner with <br /> <span className="text-blue fw-bold"> Robotic Automation Expert (RAX)?</span></h1>
              <div className="col-sm-6">
                <div className="py-3">
                  <h3 className="fw-bold"><span className="text-blue">Expand</span> your service and product offerings</h3>
                  <p>Take advantage of having a wider product portfolio for your company</p>
                </div>
                <div className="py-3">
                  <h3 className="fw-bold"><span className="text-blue">Increase</span> your revenue</h3>
                  <p>Leverage your network for additional revenue while they harness the rewards of RPA</p>
                </div>
                <div className="py-3">
                  <h3 className="fw-bold"><span className="text-blue">Build</span> new skills for your team</h3>
                  <p>Be ahead of the curve and learn the fastest growing software technology: Robotic Process Automation (RPA)</p>
                </div>
              </div>
              <div className="col-sm-6">
                <img src="img/rax-editor-image.png" className="img-fluid" alt="Download free RPA rool" />
                <p className="text-center"><a role="button" className="btn btn-lg btn-warning shadow" href="https://www.raxsuite.com/freedownload" target="_blank">Get RAX EDITOR free</a></p>
              </div>
            </div>
          </div>
        </section>
    
        <section id="signup" ref={ formElt }>
          <div className="container p-5">
            <div className="row py-5">
              <div className="col-sm-6">
                <img src="img/rax-signup.png" className="img-fluid" alt="RPA Reseller Partnership" />
                <h2 className="pt-4">Be an <span className="text-blue fw-bold"> authorized seller</span> of RAX</h2>
                <p>Please fill out the form below. Our team will be in touch with you to schedule a meeting.</p>

                {
                  formStatus !== 'success' ?
                    formStatus !== 'error' ?
                    <PartnershipForm
                      onSuccess={ onFormSuccess }
                      onError={ onFormError } /> :
                    <PartnershipFormError /> :
                    <PartnershipFormSuccess />
                }

              </div>
  
              <div className="col-sm-6">
                <div className="py-3">
                  <h1>Becoming a <span className="text-yellow fw-bold"> Partner</span></h1>
                  <p>Reach your business goals when you partner with us</p>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <img src="img/icon-sales.png" alt="RAX Sales Training" />
                  </div>
                  <div className="flex-grow-1 ms-3 mb-5">
                    <h5 className="fw-bold">RAX Sales Training</h5>
                    <p>Equip your sales team with the necessary skills on how to engage with your clients</p>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <img src="img/icon-training.png" alt="RPA Training" />
                  </div>
                  <div className="flex-grow-1 ms-3 mb-5">
                    <h5 className="fw-bold">RAX EDITOR Fundamentals Training</h5>
                    <p>Have your team go through basic RPA training to better understand the product</p>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <img src="img/icon-collaterals.png" alt="RPA Training" />
                  </div>
                  <div className="flex-grow-1 ms-3 mb-5">
                    <h5 className="fw-bold">Marketing Collaterals</h5>
                    <p>Readily available RAX assets for your marketing team</p>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <img src="img/icon-support.png" alt="RPA Training" />
                  </div>
                  <div className="flex-grow-1 ms-3 mb-5">
                    <h5 className="fw-bold">Partnership Support</h5>
                    <p>Reach us for any sales related concernsm</p>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <img src="img/icon-collab.png" alt="RPA Training" />
                  </div>
                  <div className="flex-grow-1 ms-3 mb-5">
                    <h5 className="fw-bold">Kick off Collaboration</h5>
                    <p>Jump start your initial client meeting with the help of our team</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    
        <section id="rpa-use-cases">
          <div className="container py-5">
            <h1 className="p-5">Check out these <span className="text-blue fw-bold"> RPA Use Cases</span></h1>
            <div className="row px-5">
              <div className="col-sm-6 pb-5">
                <img src="img/rpa-use-case-01.png" className="img-fluid shadow" alt="RPA use case inventory management" />
              </div>
              <div className="col-sm-6">
                <h3 className="fw-bold">Save Up to ₱48M Annually with RPA in Inventory Management</h3>
                <p>Based on a retail study conducted by RAX, automated inventory cost uploading resulted in 13,000 working hours saved and up to P6M annual business cost savings. Moreover, RAX EDITOR can perform adjustment for zero quantity — usually taking 8 working hours per store manually — in just 30 minutes per store, with expected P48M annual savings.</p>
                <p><a href="https://blog.raxsuite.com/save-up-to-%e2%82%b148m-annually-with-rpa-in-inventory-management/" target="_blank">Learn more <i className="bi bi-box-arrow-in-up-right"></i></a></p>
              </div>
            </div>
            <div className="row p-5">
              <div className="col pb-5">
                <div className="card shadow">
                  <img src="img/rpa-use-case-02.png" className="card-img-top" alt="RPA use case hotel management" />
                  <div className="card-body">
                    <h3 className="fw-bold">How RPA Helped a Japanese Hotel Save Around USD10,800 Annually</h3>
                    <p className="card-text">Manually adjusting accommodation rates depending on the changing factors like tourist arrivals entail unnecessary tedious work for the hotel staff.</p>
                    <p><a href="https://blog.raxsuite.com/how-rpa-helped-hotels-in-japan-save-around-usd-10800-annually/" target="_blank">Learn more <i className="bi bi-box-arrow-in-up-right"></i></a></p>
                  </div>
                </div>
              </div>
              <div className="col pb-5">
                <div className="card shadow">
                  <img src="img/rpa-use-case-03.png" className="card-img-top" alt="RPA use case banking and finance" />
                  <div className="card-body">
                    <h3 className="fw-bold">Monstarlab Helps Japanese Bank Adapt to RPA</h3>
                    <p className="card-text">Monstarlab, an emerging leader in RPA software solutions became influential in the digital transformation journey of Shimane Chuo Shinkin Bank, a local union bank in Izumo, Japan.</p>
                    <p><a href="https://blog.raxsuite.com/monstarlab-helps-japanese-bank-adapt-to-rpa/" target="_blank">Learn more <i className="bi bi-box-arrow-in-up-right"></i></a></p>
                  </div>
                </div>
              </div>
              <div className="col ">
                <div className="card shadow">
                  <img src="img/rpa-use-case-04.png" className="card-img-top" alt="RPA use case medical" />
                  <div className="card-body">
                    <h3 className="fw-bold">Reports Creation in Medical Industry Can Save Up to ₱2.4M Yearly with RPA</h3>
                    <p className="card-text">For the medical industry responsible for saving lives by promoting health and providing treatment with goods and services backed by science and data, reports creation is especially critical.</p>
                    <p><a href="https://blog.raxsuite.com/reports-creation-in-medical-industry-can-save-up-to-%e2%82%b12-4m-yearly-with-rpa/" target="_blank">Learn more <i className="bi bi-box-arrow-in-up-right"></i></a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    
        <section id="options">
          <div className="container py-5">
            <h1 className="p-5 text-center">Other options <span className="text-blue fw-bold"> for you</span></h1>
            <div className="row px-5 pb-5">
              <div className="col-sm-4">
                <div className="card mb-3 p-3">
                  <div className="row g-0">
                    <div className="col-md-4 text-center">
                      <img src="img/icon-laptop.png" className="img-fluid rounded-start p-3" alt="Download free RPA tool" />
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title fw-bold">Download your RPA software</h5>
                        <a role="button" className="btn btn-warning shadow d-md-block" href="https://www.raxsuite.com/freedownload" target="_blank">Go to download</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card mb-3 p-3">
                  <div className="row g-0">
                    <div className="col-md-4 text-center">
                      <img src="img/icon-key.png" className="img-fluid rounded-start p-3" alt="Download free RPA tool" />
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title fw-bold">Consult us for RPA licenses</h5>
                        <a role="button" className="btn btn-warning shadow d-md-block" href="https://www.raxsuite.com/contact" target="_blank">Message us here</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card mb-3 p-3">
                  <div className="row g-0">
                    <div className="col-md-4 text-center">
                      <img src="img/icon-flow.png" className="img-fluid rounded-start p-3" alt="Download free RPA tool" />
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title fw-bold">Contact us for Proof of Concept </h5>
                        <a role="button" className="btn btn-warning shadow d-md-block" href="https://www.raxsuite.com/contact" target="_blank">Go to contact form</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    
        <footer>
          <div className="container">
            <div className="row">
              <div className="col">
                Copyright © All Rights Reserved. <a href="https://www.raxsuite.com" target="_blank">RAX Automation Suite</a> by <a href="https://monstar-lab.com/ph" target="_blank">Monstarlab</a> | <a href="https://www.raxsuite.com/privacy-policy" target="_blank">Privacy Policy</a>
              </div>
            </div>
          </div>
        </footer>
    </>
  );
}

export default App;
